import gql from 'graphql-tag';

const BROKER_LIST_ADD = gql`
  mutation Mutation($broker: String!) {
    addBroker(broker: $broker) {
      code
    }
  }
`;

export default BROKER_LIST_ADD;
